
import React from 'react';
import axios from '../utils/axios';
import { toast } from 'react-toastify';
import Translate from '../components/translate/conf';
import ReactDOMServer from 'react-dom/server'
import { Link } from 'react-router-dom'
import { Translation } from 'react-i18next';
import ModalLoading from '@app/components/modal-loading/modal-loading';
import { Checkbox } from '@app/components/index';

export default class OltStatusConfigPage extends React.Component {

  constructor(props) {
    super(props)
    axios({
      url: '/api/olttable/' + this.props.match.params.id,
    })
      .then((response) => {
        const ponVlanId = [
          response.data.data['ucCfgOLTPON0VlanId'],
          response.data.data['ucCfgOLTPON1VlanId']
        ]
        const enableVlan = [
          ponVlanId[0] != '',
          ponVlanId[1] != ''
        ]
        const enDiscardUntagged = [
          enableVlan[0] ? response.data.data['ucCfgOLTPON0DisUntagged'] == '1' : false,
          enableVlan[1] ? response.data.data['ucCfgOLTPON1DisUntagged'] == '1' : false
        ]
        let newData = {
          ...response.data.data,
          enableVlan: enableVlan,
          enDiscardUntagged: enDiscardUntagged,
          ponVlanId: ponVlanId
        }
        this.setState(newData)
      })
      .catch((err) => console.log(err))
  }

  state = {
    ucCfgOLTName: "",
    oltAction: "0",
    ucCfgOLTMac: "",
    ucCfgOLTSlotIndex: "",
    ucCfgOLTIpAddress: "",
    id: "",
    mLoading: false,
    enableVlan: [false, false],
    enDiscardUntagged: [true, true],
    ponVlanId: ['', '']
  }

  handleChangeName = event => {
    this.setState({
      ucCfgOLTName: event.target.value,
    });
  }

  doEnableVlan = (pon, value) => {
    this.state.enableVlan[pon] = value
    this.state.ponVlanId[pon] = value ? this.state.ponVlanId[pon] : ''
    this.state.enDiscardUntagged[pon] = value
    this.setState({
      enableVlan: this.state.enableVlan,
      ponVlanId: this.state.ponVlanId,
      enDiscardUntagged: this.state.enDiscardUntagged
    });
  }

  handleEnableVlan0 = value => {
    this.doEnableVlan(0, value)
  }

  handleEnableVlan1 = value => {
    this.doEnableVlan(1, value)
  }

  doChangeVlanId = (pon, event) => {
    this.state.ponVlanId[pon] = event.target.value
    this.setState({
      ponVlanId: this.state.ponVlanId,
    });
  }

  handleChangeVlanId0 = event => {
    this.doChangeVlanId(0, event)
  }

  handleChangeVlanId1 = event => {
    this.doChangeVlanId(1, event)
  }

  doDisUntagged = (pon, value) => {
    this.state.enDiscardUntagged[pon] = value
    this.setState({
      enDiscardUntagged: this.state.enDiscardUntagged,
    });
  }

  handleDisUntagged0 = value => {
    this.doDisUntagged(0, value)
  }

  handleDisUntagged1 = value => {
    this.doDisUntagged(1, value)
  }

  handleChangeIPAddress = event => {
    this.setState({
      ucCfgOLTIpAddress: event.target.value,
    });
  }

  handleChangeReset = event => {
    this.setState({
      oltAction: event.target.value,
    });
  }

  doCheckVlan = pon => {
    const vlanId = parseInt(this.state.ponVlanId[pon])
    if( this.state.ponVlanId[pon] === '' || vlanId > 0 && vlanId < 4096 ){
      if( this.state.ponVlanId[pon] === '' ){
        this.doEnableVlan(pon,false)
      }
      return true
    }
    return false
  }

  handleConfiguration = (e) => {
    e.preventDefault();
    if ( this.doCheckVlan(0) && this.doCheckVlan(1) ) {
      var bodyFormData = {
        ucCfgOLTName: this.state.ucCfgOLTName,
        ucCfgOLTIpAddress: this.state.ucCfgOLTIpAddress,
        ucCfgOLTPON0VlanId: this.state.ponVlanId[0],
        ucCfgOLTPON0DisUntagged: this.state.enDiscardUntagged[0] ? "1" : "",
        ucCfgOLTPON1VlanId: this.state.ponVlanId[1],
        ucCfgOLTPON1DisUntagged: this.state.enDiscardUntagged[1] ? "1" : "",
      }
      this.setState({ mLoading: true })
      axios({
        method: 'post',
        url: '/api/olttable/' + this.state.id,
        data: bodyFormData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then((response) => {
        if (response.data.err !== undefined && response.data.err === "") {
          toast.success(<Translate transVar='OLT.Status.Config.ApplySuccess' />);
        } else {
          console.log(response.data.err)
          let label = ReactDOMServer.renderToString(<Translate transVar='error.label' />)
          toast.error(label + response.data.err)
        }
        this.setState({ mLoading: false })
      }).catch((err) => {
        //handle error
        console.log(err)
        let label = ReactDOMServer.renderToString(<Translate transVar='error.label' />)
        toast.error(label + err)
        this.setState({ mLoading: false })
      });
    } else {
      let err = ReactDOMServer.renderToString(<Translate transVar='error.InvalidVlanId' />)
      let label = ReactDOMServer.renderToString(<Translate transVar='error.label' />)
      toast.error(label + ' ' + err)
      this.setState({ mLoading: false })
    }
  }

  handleManagement = (e) => {
    e.preventDefault();
    if (this.state.oltAction !== "0") {
      var bodyFormData = {
        slot_id: this.state.id
      }
      this.setState({ mLoading: true })
      axios({
        method: 'post',
        url: this.state.oltAction,
        data: bodyFormData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then((response) => {
        if (response.data.err !== undefined && response.data.err === "") {
          toast.success(<Translate transVar='OLT.Status.Config.ApplySuccess' />);
        } else {
          console.log(response.data.err)
          let label = ReactDOMServer.renderToString(<Translate transVar='error.label' />)
          toast.error(label + response.data.err)
        }
        this.setState({ mLoading: false })
      }).catch((err) => {
        //handle error
        console.log(err)
        let label = ReactDOMServer.renderToString(<Translate transVar='error.label' />)
        toast.error(label + err)
        this.setState({ mLoading: false })
      });
    }
  }

  render() {
    return (
      <Translation>
        {
          t => (
            <>
              <div className="container-fluid">
                <section className="content-header">
                  <div className="container-fluid">
                    <div className="row mb-2">
                      <div className="col-sm-6">
                        <h1>{t('OLT.Status.Config.Title')}</h1>
                      </div>
                      <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                          <li className="breadcrumb-item">
                            {t('menusidebar.label.OLT.Parent')}
                          </li>
                          <li className="breadcrumb-item">
                            <Link to={{ pathname: `/olt/status` }}> {t('menusidebar.label.OLT.Status')}</Link>
                          </li>
                          <li className="breadcrumb-item active">
                            {t('OLT.Status.Config.Title')}
                          </li>
                        </ol>
                      </div>
                    </div>
                  </div>
                </section>
                <div className="row">
                  <div className="col-md-5">
                    <div className="card card-primary">
                      <div className="card-header">
                        <h3 className="card-title"> {t('OLT.Status.Config.Configuration')}</h3>
                      </div>
                      <ModalLoading show={this.state.mLoading} />
                      <form onSubmit={this.handleConfiguration}>
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group">
                                <label htmlFor="ucCfgOLTName">{t('OLT.Name')}</label>
                                <input type="text" className="form-control" id="ucCfgOLTName" placeholder={t('OLT.Name')} value={this.state.ucCfgOLTName} onChange={this.handleChangeName} />
                              </div>
                              <div className="form-group">
                                <label htmlFor="ucCfgOLTMac">{t('OLT.MACAddress')}</label>
                                <input type="text" className="form-control" id="ucCfgOLTMac" value={this.state.ucCfgOLTMac} disabled />
                              </div>
                              <div className="form-group">
                                <label htmlFor="ucCfgOLTSlotIndex">{t('OLT.Slot')}</label>
                                <input type="text" className="form-control" id="ucCfgOLTSlotIndex" value={this.state.ucCfgOLTSlotIndex} disabled />
                              </div>
                              { (localStorage.getItem('showOLTAddress') === "true") &&
                                
                                  <div className="form-group">
                                    <label htmlFor="ucCfgOLTIPAddress">{t('OLT.IPAddress')}</label>
                                    <input type="text" className="form-control" id="ucCfgOLTIPAddress" placeholder={t('OLT.IPAddress')} value={this.state.ucCfgOLTIpAddress} onChange={this.handleChangeIPAddress} />
                                  </div>
                              }
                              <hr style={{ marginBottom: '5px' }} />
                              <hr style={{ marginTop: '5px' }} />
                            </div>
                            <div className="col-md-6">
                              <div className='subtitle'>Uplink-0</div>
                              <div className="form-group">
                                <Checkbox checked={this.state.enableVlan[0]} label={t('OLT.Status.Config.EnableVlan')} onChange={this.handleEnableVlan0} />
                              </div>
                              <div className="form-group">
                                <label htmlFor="ucCfgOLTVlanId">{t('OLT.Status.Config.VlanId')}</label>
                                <input type="text" className="form-control" id="ucCfgOLTVlanId"
                                  disabled={!this.state.enableVlan[0]} value={this.state.ponVlanId[0]} onChange={this.handleChangeVlanId0} />
                              </div>
                              <div className="form-group">
                                <Checkbox checked={this.state.enDiscardUntagged[0]} label={t('OLT.Status.Config.DisUntagged')} onChange={this.handleDisUntagged0} disabled={!this.state.enableVlan[0]} />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className='subtitle'>Uplink-1</div>
                              <div className="form-group">
                                <Checkbox checked={this.state.enableVlan[1]} label={t('OLT.Status.Config.EnableVlan')} onChange={this.handleEnableVlan1} />
                              </div>
                              <div className="form-group">
                                <label htmlFor="ucCfgOLTVlanId">{t('OLT.Status.Config.VlanId')}</label>
                                <input type="text" className="form-control" id="ucCfgOLTVlanId"
                                  disabled={!this.state.enableVlan[1]} value={this.state.ponVlanId[1]} onChange={this.handleChangeVlanId1} />
                              </div>
                              <div className="form-group">
                                <Checkbox checked={this.state.enDiscardUntagged[1]} label={t('OLT.Status.Config.DisUntagged')} onChange={this.handleDisUntagged1} disabled={!this.state.enableVlan[1]} />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-footer">
                          <button type="submit" className="btn btn-primary">{t('Button.Apply')}</button>
                          <button type="button" className="btn btn-default float-right" onClick={() => this.props.history.goBack()}>{t('Button.Back')}</button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card card-primary">
                      <div className="card-header">
                        <h3 className="card-title"> {t('OLT.Status.Config.Management')}</h3>
                      </div>
                      <form onSubmit={this.handleManagement}>
                        <div className="card-body">
                          <label>{t('OLT.Status.Config.Action')}</label>
                          <select className="custom-select" onChange={this.handleChangeReset}>
                            <option value="0"></option>
                            <option value="/api/slot/reset">{t('OLT.Status.Config.ActionReset')}</option>
                            <option value="/api/slot/enable">{t('OLT.Status.Config.ActionEnable')}</option>
                            <option value="/api/slot/disable">{t('OLT.Status.Config.ActionDisable')}</option>
                          </select>
                        </div>
                        <div className="card-footer">
                          <button type="submit" className="btn btn-primary">{t('Button.Apply')}</button>
                          <button type="button" className="btn btn-default float-right" onClick={() => this.props.history.goBack()}>{t('Button.Back')}</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )
        }
      </Translation>
    )
  }
}
